<template>
  <div class="bg-white w-screen h-screen">
    <!-- NAVEGACIÒN -->
    <nav class="bg-white w-full h-auto fixed px-4 py-2 z-20  "> 
      <div class="flex">
        <div class="flex items-center justify-center w-50">
          <img src="@/assets/logos-explorador/ct-cg-horizontal.png" class="h-8 md:h-8" />
        </div>
        <!-- <div class="flex items-center justify-center w-40">
          <img src="@/assets/centroGeo_logo.png" class="h-12 md:h-16" />
        </div>   -->
        <div class="flex items-center justify-center w-40">
          <img src="@/assets/logos-explorador/gi-color-horizontal.png" class="h-8 md:h-8" />
        </div>
        <div class="flex items-center justify-center w-40">
          <img src="@/assets/logo_monitoreo_comunitario_ppd.png" class="h-12 md:h-16" />
        </div>    
        <div class="flex items-center justify-center w-40">
          <img src="@/assets/logo-ppd_letras_2.png" class="h-13 md:h-15" />
        </div>      
        <div class="flex items-center justify-center w-40">
          <img src="@/assets/Logo_GEF.png" class="h-12 md:h-16" />
        </div>
        <div class="flex items-center justify-center w-40">
          <img src="@/assets/logo-PNUD.png" class="h-12 md:h-16" />
        </div>       
        <div class="flex-1"></div>
        <!-- USUARIO - CERRAR SESIÒN -->
        <div class="relative group flex">
          <div class="flex items-center px-2 py-2 cursor-pointer">
            <img class="h-8 w-8 rounded-full" :src="profile_image" @error="defaultProfile" />
            <span class="ml-2 text-gray-900 font-bold">{{user}}</span>
            <span class="text-gray-900">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path d="M7 10l5 5 5-5z" />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
            </span>
          </div>
          <div class="absolute right-0 py-2 w-48 bg-white rounded-lg shadow-xl text-left hidden group-hover:block" style="margin-top: 4rem;;">
            <a
              v-on:click="updateProfileModal"
              href="#"
              class="flex px-4 py-2 text-gray-800 hover:bg-cdmx-green hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
                />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
              <span class="ml-2 font-bold">Perfil</span>
            </a>
            <a
              @click="dologout"
              href="#"
              class="flex px-4 py-2 text-gray-800 hover:bg-cdmx-green hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                />
              </svg>
              <span class="ml-2 font-bold">Cerrar sesión</span>
            </a>
          </div>
        </div>
      </div>
      
      
    </nav>

    <div>
      <!-- SIDEBAR FIJO -->
      <div class="w-56 fixed top-0 bottom-0 bg-white ppd-lateral bg-ppd"  >
        <div class="  ">
          <ul class="flex flex-row md:flex-col items-center md:items-stretch">
          <li class="text-left">
            <router-link
              to="/mapa"
              class="px-5 py-3 flex flex-col md:flex-row items-center hover:bg-cdmx-green hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"
                />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
              <span class="ml-2 tracking-wide font-bold">Mapa</span>
            </router-link>
          </li>


          <li class="text-left">
            <router-link
              to="/adminexplorer"
              class="px-5 py-3 flex flex-col md:flex-row items-center hover:bg-cdmx-green hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
                />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
              <span class="ml-2 tracking-wide font-bold">Explorar</span>
            </router-link>
          </li>


          <li class="text-left" v-if="is_admin == 'true'">
            <router-link
              to="/monitores"
              class="px-5 py-3 flex flex-col md:flex-row items-center hover:bg-cdmx-green hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
                />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>

              <span class="ml-2 tracking-wide font-bold">Monitores</span>
            </router-link>
          </li>

          
          <li class="text-left" v-if="is_admin == 'true'">
            <router-link
              to="/gestores"
              class="px-5 py-3 flex flex-col md:flex-row items-center hover:bg-cdmx-green hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.99 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm3.61 6.34c1.07 0 1.93.86 1.93 1.93 0 1.07-.86 1.93-1.93 1.93-1.07 0-1.93-.86-1.93-1.93-.01-1.07.86-1.93 1.93-1.93zm-6-1.58c1.3 0 2.36 1.06 2.36 2.36 0 1.3-1.06 2.36-2.36 2.36s-2.36-1.06-2.36-2.36c0-1.31 1.05-2.36 2.36-2.36zm0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68zM11.99 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15-1.17 2.97-4.06 5.09-7.45 5.09z"
                />
                <path fill="none" d="M0 0h24v24H0z" />
              </svg>

              <span class="ml-2 tracking-wide font-bold">Gestores</span>
            </router-link>
          </li>


          <li class="text-left">
            <router-link
              to="/registros"
              class="px-5 py-3 flex flex-col md:flex-row items-center hover:bg-cdmx-green hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
              <span class="ml-2 tracking-wide font-bold">Registros</span>
            </router-link>
          </li>

          <li class="text-left" v-if="is_admin == 'true'">
            <router-link
              to="/administracion"
              class="px-5 py-3 flex flex-col md:flex-row items-center hover:bg-cdmx-green hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
                />
              </svg>
              <span class="ml-2 tracking-wide font-bold">Administración</span>
            </router-link>
          </li>

        </ul>
        </div>
      </div>

      <!-- CONTENIDO -->
      <div class="ml-56 pt-20 h-screen bg-cdmx-gray">
        <keep-alive include="Map">
          <router-view :key="$route.fullPath" />
        </keep-alive>
      </div>
    </div>

    <profile-modal :showing="showProfileModal" @close="closeProfileModal"></profile-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"; 
import profileModal from "./ProfileModal"; 
import defaultProfileImg from "@/assets/default-profile.png";

export default {
  name: "dashboard",
  data() {
    return {
      user: localStorage.getItem("name"),
      is_admin: localStorage.getItem("is_admin"),
      profile_image: localStorage.getItem("profile_image"),
      showProfileModal: false
    };
  },
  computed: {
    ...mapState(["loggingIn", "loginError", "accessToken"])
  },
  components: { profileModal },
  methods: {
    ...mapActions(["logout"]),
    dologout() {
      this.logout({});
    },
    getProfileImage() {
      console.log(" this.profile_image",  this.profile_image)
      if (!this.profile_image || this.profile_image === "null" || this.profile_image === "") {
        this.profile_image = defaultProfileImg; // 👈 Usa la importación
      }
    },
    updateProfileModal() {
      this.showProfileModal = true;
    },
    closeProfileModal() {
      this.showProfileModal = false;
      this.profile_image = localStorage.getItem("profile_image");
    },
    defaultProfile(event) {
      const fallback = defaultProfileImg;
      if (event && event.target && event.target.src && event.target.src.includes(fallback)) return;
      this.profile_image = fallback;
    },
  },
  mounted() {
    this.getProfileImage();
  }
};
</script>

<style scoped>
  .router-link-active {
    background-color: #00000048;
    color: #ffffff;
  }

  .h-13 {
    height: 3.25rem;
  }
  .h-15 {
    height: 3.75rem;
  }

  .bg-ppd {
    background-color: #16663e;
  }

  .ppd-lateral{
    padding-top: 80px;
    color: white;
  } 

</style>
